

export class Timeout
{

    static readonly NO_TIMEOUT: number = -1;
    protected timeout: number = Timeout.NO_TIMEOUT;
    
    protected millis: number;

    protected callback: () => void;

    public constructor(millis: number, callback: () => void)
    {
        this.millis = millis;
        this.callback = callback;
    }

    public Start(): void
    {
        this.InternalStop();
        this.timeout = window.setTimeout(() => this.Triggered(), this.millis);
    }

    public Stop(): void
    {
        this.InternalStop();
    }

    protected InternalStop(): void
    {
        if (this.timeout != Timeout.NO_TIMEOUT)
        {
            window.clearTimeout(this.timeout);
            this.timeout = Timeout.NO_TIMEOUT;
        }
    }


    protected Triggered(): void
    {
        this.timeout = Timeout.NO_TIMEOUT;
        this.callback();
    }

    public Dispose(): void
    {
        this.InternalStop();
    }
}